import {
  ADMIN_USER_TRANSACTIONS_PENDING_LOCATION,
  AdminWalletBankResponse,
  BankV2,
  ConnectYourBank,
  CreditCard,
  DragScrollX,
  H3,
  User,
  UserRole,
  WalletBankV2Response,
  Wallets,
  getPartnerBankV2,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCreditCardDelete } from '../Bank/UserCreditCardDelete';
import { UserCreditCardEditBalance } from '../Bank/UserCreditCardEditBalance';

export const BankWallet = ({
  setLoading,
  userId,
  user,
}: {
  setLoading: Dispatch<SetStateAction<boolean>>;
  userId: string;
  user: User;
}) => {
  const navigate = useNavigate();
  const [wallet, setWallet] = useState<WalletBankV2Response | null>(null);

  const [addBankModal, setAddBankModal] = useState<Wallets | null>(null);
  const [connectYourBankModal, setConnectYourBankModal] =
    useState<Wallets | null>(null);
  const [deleteBankModal, setDeleteBankModal] = useState<
    Wallets | boolean | null
  >(null);
  const [editBalanceModal, setEditBalanceModal] = useState<
    Wallets | boolean | null
  >(null);
  async function getWalletInfo() {
    setLoading(true);
    const { data } = await getPartnerBankV2(userId);
    setWallet(data.data);

    setLoading(false);
  }

  useEffect(() => {
    getWalletInfo();
  }, []);

  const handleConnectBank = (wallet: Wallets | null) => {
    if (wallet?.isBankConnected) {
      setAddBankModal(wallet);
    } else {
      setConnectYourBankModal(wallet);
    }
  };

  const handlePendingTransactions = (wallet: Wallets) => {
    navigate(
      ADMIN_USER_TRANSACTIONS_PENDING_LOCATION.replace(
        ':id',
        userId.toString()
      ).replace(':locationId', wallet.simpleLocation.id.toString())
    );
  };

  const handleEditBallance = (wallet: Wallets) => {
    setEditBalanceModal(wallet);
  };

  const handleDeleteBank = (wallet: Wallets | boolean | null) => {
    setDeleteBankModal(wallet);
  };

  if (!wallet) return null;

  return (
    <>
      {wallet.wallets.length > 0 && <H3 $mb="4">vPay Balance</H3>}
      <DragScrollX width="400px" widthMD="400px">
        {wallet?.wallets?.map((wallet, i) => (
          <div key={i}>
            <CreditCard
              key={i}
              wallet={wallet}
              handleConnectBank={handleConnectBank}
              title={wallet.simpleLocation.name}
              userRole={UserRole.partner}
              handlePendingTransactions={handlePendingTransactions}
              handleEditBallance={handleEditBallance}
              handleDeleteBank={handleDeleteBank}
            />
          </div>
        ))}
      </DragScrollX>

      {wallet && (
        <>
          <BankV2
            userRole={UserRole.partner}
            userId={Number(userId)}
            wallet={addBankModal as Wallets}
            modalIsOpen={addBankModal}
            setModalIsOpen={
              setAddBankModal as Dispatch<
                SetStateAction<Wallets | boolean | null>
              >
            }
            setWallet={
              setWallet as Dispatch<
                SetStateAction<
                  WalletBankV2Response | AdminWalletBankResponse | null
                >
              >
            }
            user={user}
          />

          <ConnectYourBank
            setModalIsOpen={
              setAddBankModal as Dispatch<
                SetStateAction<Wallets | boolean | null>
              >
            }
            isOpen={connectYourBankModal}
            setIsOpen={
              setConnectYourBankModal as Dispatch<
                SetStateAction<Wallets | boolean | null>
              >
            }
          />

          <UserCreditCardDelete
            userId={userId}
            getBank={getWalletInfo}
            deleteBankModal={deleteBankModal}
            setDeleteBankModal={handleDeleteBank}
            wallet={deleteBankModal as Wallets}
            setLoading={setLoading}
            userRole={UserRole.partner}
          />
          <UserCreditCardEditBalance
            userId={Number(userId)}
            getBank={getWalletInfo}
            editBalanceModal={editBalanceModal}
            setEditBalanceModal={setEditBalanceModal}
            wallet={editBalanceModal as Wallets}
            userRole={UserRole.partner}
            setLoading={setLoading}
          />
        </>
      )}
    </>
  );
};
